export default {"src":"https://cdn.jetlend.ru/_next/static/media/lead-form-background.27a869ef.svg","height":268,"width":564,"blurWidth":0,"blurHeight":0};